import {
  PortfolioStakingOverviewQuery,
  PortfolioStakingOverviewQuery$data,
  PortfolioStakingOverviewQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export interface PortfolioStakingOverviewResponse {
  data: PortfolioStakingOverviewQuery$data;
  errors?: string[];
}

export const getPortfolioStakingOverviewData =
  async (): Promise<PortfolioStakingOverviewResponse> => {
    const response = await gqlNetworkFetch<PortfolioStakingOverviewQuery>(
      PortfolioStakingOverviewQueryNode.params,
      {},
    );

    return response;
  };
